var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "48couzb6na",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1205 -326) translate(1205 326)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FFC43C"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#48couzb6na)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M8.5 14h-5c-.276 0-.5.224-.5.5v1c0 .276.224.5.5.5H4c0 .553.447 1 1 1h2c.553 0 1-.447 1-1h.5c.276 0 .5-.224.5-.5v-1c0-.276-.224-.5-.5-.5zM6 0C2.687 0 0 2.687 0 6c0 1.539.584 2.938 1.537 4 .827.827 1.203 1.897 1.361 2.51.069.267.326.49.602.49h5c.276 0 .533-.223.602-.49.158-.612.534-1.683 1.361-2.51C11.416 8.938 12 7.539 12 6c0-3.313-2.687-6-6-6zm2.789 7c-.59 0-.384-1.372-1.4-2.389C6.373 3.596 5 3.801 5 3.211c0-.591 2.189-1.629 3.805-.016C10.419 4.81 9.38 7 8.789 7z",
    transform: "translate(9 6)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlub);
export default __webpack_public_path__ + "static/media/blub.2212156f20a29d609142cfb2af03bbec.svg";
export { ForwardRef as ReactComponent };